import { resolveColor } from "@insite/mobius/utilities";
import { StyledTheme } from "@toolkit/Framework/Types/StyledTheme";

export default (color = "", theme?: StyledTheme) => {
    if (typeof window === "undefined") {
        return color;
    }

    return window.encodeURIComponent(theme ? resolveColor(color, theme) : color);
};
